import { StarterArticles, StarterArticleSource } from '../../../../types/StarterGuideTypes';

export const articles: StarterArticles = {
  title: 'Learn More',
  articles: [
    {
      title: 'New Puppy Checklist: 9 Things You Need Before Bringing Home a New Puppy',
      image: '/wp-content/uploads/bringing-home-a-new-puppy-HERO-300x169.jpg',
      link: '/new-puppy-checklist-9-things-you-need-before-bringing-home-a-new-puppy/',
      source: StarterArticleSource.BE_CHEWY,
    },
    {
      title: 'Puppy Teething: Symptoms, Solutions and When to Call Your Vet',
      image: '/wp-content/uploads/2019/12/18160132/puppy_teething_symptoms-300x160.jpg',
      link: '/what-to-expect-with-puppy-teething/',
      source: StarterArticleSource.BE_CHEWY,
    },
    {
      title: 'How to Choose and Fit a No-Pull Dog Harness',
      image:
        '/sites/default/files/styles/additional_slideshows_281_192/public/dog-handler-walks-with-her-little-dog-on-a-road-two-cute-obedient-picture-id953661392.jpg',
      link: '/dog/training/how-choose-and-fit-no-pull-dog-harness',
      source: StarterArticleSource.PET_MD,
    },
    {
      title: 'Choosing the Right Dog Harness for Your Pet',
      image: '/wp-content/uploads/2018/12/17140305/dog-harness-768x461.jpg',
      link: '/choosing-the-right-dog-harness-for-your-pet/',
      source: StarterArticleSource.BE_CHEWY,
    },
  ],
};
